import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ChevronDown, ChevronUp } from "lucide-react";

function FAQPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      q: "Как работает обмен?",
      a: "Выберите валюты для обмена, введите сумму, укажите email и адрес кошелька получателя. После создания заявки вы получите адрес для отправки криптовалюты. Как только средства поступят, мы автоматически выполним обмен и отправим средства на ваш кошелёк."
    },
    {
      q: "Нужна ли регистрация?",
      a: "Нет, для обмена регистрация не требуется. Вам нужно только указать email для связи и адрес кошелька для получения средств."
    },
    {
      q: "Какая комиссия за обмен?",
      a: "Комиссия составляет от 1% до 2% в зависимости от направления обмена. Точная комиссия отображается при расчёте суммы обмена."
    },
    {
      q: "Сколько времени занимает обмен?",
      a: "Обмен занимает от 5 до 30 минут в зависимости от скорости подтверждения транзакции в сети блокчейн. В большинстве случаев обмен происходит за 10-15 минут."
    },
    {
      q: "Какие криптовалюты поддерживаются?",
      a: "Мы поддерживаем более 20 популярных криптовалют, включая Bitcoin (BTC), Ethereum (ETH), Tether (USDT), Litecoin (LTC), Ripple (XRP), Binance Coin (BNB) и другие."
    },
    {
      q: "Есть ли минимальная сумма обмена?",
      a: "Да, минимальная сумма обмена зависит от криптовалюты и обычно составляет эквивалент $10-20. Точный минимум отображается при создании заявки."
    },
    {
      q: "Что делать, если обмен не прошёл?",
      a: "Если возникли проблемы с обменом, свяжитесь с нашей поддержкой в Telegram (@skinkosh) или по email (support@skinkosh.com). Укажите ID вашей заявки для быстрого решения."
    },
    {
      q: "Как проверить статус заявки?",
      a: "Вы можете проверить статус заявки в личном кабинете, введя email, который использовали при создании заявки."
    },
    {
      q: "Безопасен ли ваш сервис?",
      a: "Да, мы используем современные протоколы шифрования и не храним ваши средства. Все обмены происходят автоматически и безопасно."
    },
    {
      q: "Можно ли отменить заявку?",
      a: "Заявку можно отменить до момента отправки средств. После отправки криптовалюты отмена невозможна из-за необратимости блокчейн-транзакций."
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border">
        <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center gap-4">
          <Link to="/">
            <Button variant="ghost" size="sm">
              <ArrowLeft size={20} className="mr-2" />
              Назад
            </Button>
          </Link>
          <h1 className="font-heading text-xl font-bold text-primary">FAQ</h1>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <h2 className="text-3xl font-bold text-foreground mb-8">Часто задаваемые <span className="text-primary">вопросы</span></h2>
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-border rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full p-4 flex items-center justify-between text-left bg-card hover:bg-card/80 transition-colors"
              >
                <span className="font-medium text-foreground">{faq.q}</span>
                {openIndex === index ? (
                  <ChevronUp className="text-primary flex-shrink-0" size={20} />
                ) : (
                  <ChevronDown className="text-muted-foreground flex-shrink-0" size={20} />
                )}
              </button>
              {openIndex === index && (
                <div className="p-4 bg-background border-t border-border">
                  <p className="text-muted-foreground">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 bg-card border border-border rounded-lg text-center">
          <h3 className="font-bold text-foreground mb-2">Не нашли ответ?</h3>
          <p className="text-muted-foreground mb-4">Свяжитесь с нашей поддержкой</p>
          <div className="flex justify-center gap-4">
            <Button variant="outline" asChild>
              <a href="mailto:support@skinkosh.com">Email</a>
            </Button>
            <Button className="bg-primary text-primary-foreground" asChild>
              <a href="https://t.me/skinkosh" target="_blank" rel="noopener noreferrer">Telegram</a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQPage;
